export const PERMISSIONS = {
  // ─── Existentes ───────────────────────────────────────────────────────────
  SUPER_ADMINISTRADOR: 'SUPER_ADMINISTRADOR',
  ADMINISTRATIVO: 'ADMINISTRATIVO',
  ASSOCIADO_CONTATO: 'ASSOCIADO_CONTATO',
  ATENDENTE: 'ATENDENTE',
  TRATAMENTO: 'TRATAMENTO',
  GESTAO_TRATAMENTO: 'GESTAO_TRATAMENTO',
  CURSO: 'CURSO',
  GESTAO_CURSO: 'GESTAO_CURSO',
  PROFESSOR: 'PROFESSOR',
  DEBITO: 'DEBITO',
  GESTAO_DEBITO: 'GESTAO_DEBITO',
  GESTAO_AGENDA: 'GESTAO_AGENDA',

  // ─── Jurídico — Base ─────────────────────────────────────────────────────
  JURIDICO: 'JURIDICO',

  // ─── Jurídico — Audiências ────────────────────────────────────────────────
  JURIDICO_INCLUIR_AUDIENCIA: 'JURIDICO_INCLUIR_AUDIENCIA',
  JURIDICO_EXCLUIR_AUDIENCIA: 'JURIDICO_EXCLUIR_AUDIENCIA',

  // ─── Jurídico — Prazos ───────────────────────────────────────────────────
  JURIDICO_INCLUIR_PRAZO: 'JURIDICO_INCLUIR_PRAZO',
  JURIDICO_EXCLUIR_PRAZO: 'JURIDICO_EXCLUIR_PRAZO',
  JURIDICO_INCLUIR_PRAZO_ANDAMENTO: 'JURIDICO_INCLUIR_PRAZO_ANDAMENTO',

  // ─── Jurídico — Publicações ───────────────────────────────────────────────
  JURIDICO_PUBLICACAO: 'JURIDICO_PUBLICACAO',

  // ─── Jurídico — Processos ─────────────────────────────────────────────────
  JURIDICO_INCLUIR_PROCESSO: 'JURIDICO_INCLUIR_PROCESSO',
  JURIDICO_EXCLUIR_PROCESSO: 'JURIDICO_EXCLUIR_PROCESSO',
  JURIDICO_INCLUIR_OBSERVACAO_PROCESSO: 'JURIDICO_INCLUIR_OBSERVACAO_PROCESSO',
  JURIDICO_EXCLUIR_OBSERVACAO_PROCESSO: 'JURIDICO_EXCLUIR_OBSERVACAO_PROCESSO',
  JURIDICO_INCLUIR_ANDAMENTO_PROCESSO: 'JURIDICO_INCLUIR_ANDAMENTO_PROCESSO',
  JURIDICO_EXCLUIR_ANDAMENTO_PROCESSO: 'JURIDICO_EXCLUIR_ANDAMENTO_PROCESSO',

  // ─── Jurídico — Iniciais Pendentes ────────────────────────────────────────
  JURIDICO_INCLUIR_INICIAL: 'JURIDICO_INCLUIR_INICIAL',
  JURIDICO_EXCLUIR_INICIAL: 'JURIDICO_EXCLUIR_INICIAL',

  // ─── Jurídico — Cálculos ──────────────────────────────────────────────────
  JURIDICO_INCLUIR_CALCULO: 'JURIDICO_INCLUIR_CALCULO',
  JURIDICO_EXCLUIR_CALCULO: 'JURIDICO_EXCLUIR_CALCULO',

  // ─── Jurídico — Precatórios ───────────────────────────────────────────────
  JURIDICO_INCLUIR_PRECATORIO: 'JURIDICO_INCLUIR_PRECATORIO',
  JURIDICO_EXCLUIR_PRECATORIO: 'JURIDICO_EXCLUIR_PRECATORIO',

  // ─── Jurídico — Status ────────────────────────────────────────────────────
  JURIDICO_ATUALIZAR_STATUS: 'JURIDICO_ATUALIZAR_STATUS',

  // ─── Jurídico — Atendimento ───────────────────────────────────────────────
  JURIDICO_INCLUIR_ASSUNTO_ATENDIMENTO: 'JURIDICO_INCLUIR_ASSUNTO_ATENDIMENTO',

  // ─── Jurídico — Relatórios ────────────────────────────────────────────────
  JURIDICO_RELATORIO_GERAL: 'JURIDICO_RELATORIO_GERAL',
  JURIDICO_RELATORIO_GERENCIAL: 'JURIDICO_RELATORIO_GERENCIAL',
  JURIDICO_RELATORIO_FINANCEIRO: 'JURIDICO_RELATORIO_FINANCEIRO',

  // ─── Jurídico — Débitos ───────────────────────────────────────────────────
  JURIDICO_DEBITO: 'JURIDICO_DEBITO',
  JURIDICO_GESTAO_DEBITO: 'JURIDICO_GESTAO_DEBITO',

  // ─── Jurídico — Agenda / Agendamento ─────────────────────────────────────
  JURIDICO_TERCEIRIZADO: 'JURIDICO_TERCEIRIZADO',
  JURIDICO_ATENDENTE: 'JURIDICO_ATENDENTE',
  JURIDICO_GESTAO_AGENDA: 'JURIDICO_GESTAO_AGENDA',
  JURIDICO_AGENDAMENTO: 'JURIDICO_AGENDAMENTO',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];
